// Configuration EmailJS
// Pour obtenir ces clés, créez un compte sur https://www.emailjs.com/
// 1. Créez un compte gratuit
// 2. Ajoutez un service email (Gmail, Outlook, etc.)
// 3. Créez un template d'email
// 4. Récupérez vos clés dans le dashboard

export const EMAILJS_CONFIG = {
  // Clés EmailJS - Utilisent les variables d'environnement si disponibles
  // Sinon utilisent les valeurs par défaut (fallback)
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'z0Cu0-KcLqg_miILv',
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_yly3wfc',
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_jejpnxq',
};

// Debug: vérifier que les clés sont bien chargées
if (process.env.NODE_ENV === 'development') {
  console.log('EmailJS Config loaded:', {
    hasPublicKey: !!EMAILJS_CONFIG.PUBLIC_KEY,
    hasServiceId: !!EMAILJS_CONFIG.SERVICE_ID,
    hasTemplateId: !!EMAILJS_CONFIG.TEMPLATE_ID,
  });
}

// Template suggéré pour EmailJS :
// 
// Sujet: Nouvelle demande de devis - {{projectType}}
// 
// Corps du message:
// Nouvelle demande de contact depuis le site ARS Agencement
// 
// Informations client :
// - Nom : {{name}}
// - Email : {{email}}
// - Téléphone : {{phone}}
// 
// Détails du projet :
// - Type : {{projectType}}
// - Sujet : {{subject}}
// - Budget : {{budget}}
// - Délai : {{timeline}}
// 
// Description :
// {{message}}
// 
// ---
// Message envoyé depuis ars-agencement.bzh
